import { DATE_SHORT_FORMAT } from '../../../../constants/date'
import { EntityStatus } from '../../../Entity'
import {
  APPLICANT_STAGES,
  getRentalPortalApplicantIdentityLabel,
  RentalPortalApplicantIdentityCell,
} from '../../../RentalPortalApplicant'
import { getListingUnitLabel } from '../../../RentalPortalListing'
import {
  TableCellBase,
  TableDateCell,
  TableEmptyCell,
  TableTextCell,
} from '../../../Table'
import { getRentalPortalExportDate } from '../../RentalPortal.utils'
import {
  getRentalPortalApplicantPortalLabel,
  RentalPortalApplicantPortalCell,
} from '../../RentalPortalApplicantPortalCell'
import {
  getMatchChipsExportValue,
  getMatchExportValue,
  RentalPortalMatchChipsCell,
  RentalPortalMatchCriteriaPopover,
  RentalPortalMatchFitCell,
} from '../../RentalPortalMatch'
import {
  getWaitingOnExportValue,
  RentalPortalWaitingOnCell,
} from '../../RentalPortalWaitingOnCell'
import { APPLICANT_COLUMN_NAME } from '../RentalPortalApplicants.constants'
import { getApplicantWithHighlightBudget } from '../RentalPortalApplicants.utils'

export function renderApplicantsCell({ item, name, t, ...restProps }) {
  const { [name]: value } = item

  switch (name) {
    case APPLICANT_COLUMN_NAME.Listing:
      return (
        <TableTextCell
          {...restProps}
          value={getListingUnitLabel({ listing: item, t })}
        />
      )

    case APPLICANT_COLUMN_NAME.Reference:
      return (
        <RentalPortalApplicantIdentityCell
          {...restProps}
          applicant={getApplicantWithHighlightBudget(item)}
        />
      )

    case APPLICANT_COLUMN_NAME.Stage:
      return APPLICANT_STAGES[value] ? (
        <TableCellBase {...restProps}>
          <EntityStatus id={value} statuses={APPLICANT_STAGES} />
        </TableCellBase>
      ) : (
        <TableEmptyCell {...restProps} />
      )

    case APPLICANT_COLUMN_NAME.Received:
      return (
        <TableDateCell
          {...restProps}
          dateFormat={DATE_SHORT_FORMAT}
          useTodayFormat={false}
          value={value}
        />
      )

    case APPLICANT_COLUMN_NAME.WaitingOn:
      return (
        <RentalPortalWaitingOnCell {...restProps} attention={item.attention} />
      )

    case APPLICANT_COLUMN_NAME.Chips:
      return item.match ? (
        <TableCellBase {...restProps}>
          <RentalPortalMatchChipsCell match={item.match} />
        </TableCellBase>
      ) : (
        <TableEmptyCell {...restProps} />
      )

    case APPLICANT_COLUMN_NAME.Fit:
      return value ? (
        <TableCellBase {...restProps}>
          <RentalPortalMatchCriteriaPopover match={value}>
            <RentalPortalMatchFitCell match={value} />
          </RentalPortalMatchCriteriaPopover>
        </TableCellBase>
      ) : (
        <TableEmptyCell {...restProps} />
      )

    case APPLICANT_COLUMN_NAME.Portal:
      return value ? (
        <RentalPortalApplicantPortalCell {...restProps} applicant={item} />
      ) : (
        <TableEmptyCell {...restProps} />
      )

    default:
      return <TableTextCell {...restProps} value={value} />
  }
}

export function getApplicantExportValue({ item, locale, name, t, timezone }) {
  const { [name]: value } = item

  switch (name) {
    case APPLICANT_COLUMN_NAME.Listing:
      return getListingUnitLabel({ listing: item, t })

    case APPLICANT_COLUMN_NAME.Reference:
      return getRentalPortalApplicantIdentityLabel({ applicant: item, t })
    case APPLICANT_COLUMN_NAME.Stage:
      return APPLICANT_STAGES[value] ? t(APPLICANT_STAGES[value].text) : null
    case APPLICANT_COLUMN_NAME.Received:
      return getRentalPortalExportDate({ locale, timezone, value })
    case APPLICANT_COLUMN_NAME.WaitingOn:
      return getWaitingOnExportValue({ attention: item.attention, t })
    case APPLICANT_COLUMN_NAME.Chips:
      return item.match
        ? getMatchChipsExportValue({ match: item.match, t })
        : null
    case APPLICANT_COLUMN_NAME.Fit:
      return value ? getMatchExportValue({ match: value, t }) : null
    case APPLICANT_COLUMN_NAME.Portal:
      return value
        ? getRentalPortalApplicantPortalLabel({ applicant: item, t })
        : null
    default:
      return value
  }
}
